module.exports = __webpack_public_path__ + "static/media/strong_roots.6a974f74.png";